import { createPromiseClient } from "@apachedubbo/dubbo";
import { TriCompanyIssuingCarrierService } from "@onetakesolutions/cargogo-contract-web/TriCompanyDatabase_dubbo";
import transport from "../transport";

const client = createPromiseClient(TriCompanyIssuingCarrierService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
